import { render, staticRenderFns } from "./priceCreate.vue?vue&type=template&id=6b73d101&"
import script from "./priceCreate.vue?vue&type=script&lang=js&"
export * from "./priceCreate.vue?vue&type=script&lang=js&"
import style0 from "./priceCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports